// svg
export { default as Logo } from "./svg/logo.svg";
export { default as FullLogo } from "./svg/full_logo.svg";
export { default as FullLogoWhite } from "./svg/full_logo_white.svg";
export { default as TextStrip1 } from "./svg/text_strip_1.svg";
export { default as TextStrip2 } from "./svg/text_strip_2.svg";
export { default as TextStrip3 } from "./svg/text_strip_3.svg";
export { default as Ellipse } from "./svg/ellipse.svg";
export { default as Star } from "./svg/star.svg";
export { default as Stars } from "./svg/stars.svg";
export { default as Flower } from "./svg/flower.svg";
export { default as Line } from "./svg/line.svg";
export { default as LongLine } from "./svg/long_line.svg";
export { default as Sent } from "./svg/sent.svg";
export { default as GreenLeaf } from "./svg/green_leaf.svg";
export { default as YellowLeaf } from "./svg/yellow_leaf.svg";
export { default as Offering } from "./svg/offering.svg";
export { default as Dots } from "./svg/dots.svg";
export { default as SendEmail } from "./svg/send_email.svg";
export { default as Team } from "./svg/team.svg";
export { default as Project } from "./svg/project.svg";
export { default as Security } from "./svg/security.svg";
export { default as Tracking } from "./svg/tracking.svg";
export { default as Quotes } from "./svg/quotes.svg";
export { default as Vector1 } from "./svg/about_lines/vector_1.svg";
export { default as Vector2 } from "./svg/about_lines/vector_2.svg";
export { default as Vector3 } from "./svg/about_lines/vector_3.svg";
export { default as Vector4 } from "./svg/about_lines/vector_4.svg";

// image
export { default as Img1 } from "./img/img_1.jpeg";
export { default as Img2 } from "./img/img_2.jpeg";
export { default as Img3 } from "./img/img_3.jpeg";
export { default as Img4 } from "./img/img_4.jpeg";
export { default as Img5 } from "./img/img_5.jpeg";
export { default as Img6 } from "./img/img_6.jpeg";
export { default as Img7 } from "./img/img_7.jpeg";
export { default as Img8 } from "./img/img_8.jpeg";
export { default as Img9 } from "./img/img_9.jpeg";
export { default as Img10 } from "./img/img_10.jpeg";
export { default as Img11 } from "./img/img_11.jpeg";
export { default as Img12 } from "./img/img_12.jpeg";
export { default as Img13 } from "./img/img_13.jpeg";
export { default as Img14 } from "./img/img_14.jpeg";
export { default as Img15 } from "./img/img_15.png";
export { default as Img16 } from "./img/img_16.jpg";
export { default as Img17 } from "./img/img_17.jpg";
export { default as Img18 } from "./img/img_18.jpg";
export { default as Img19 } from "./img/img_19.jpg";
export { default as Img20 } from "./img/img_20.png";
export { default as Img21 } from "./img/img_21.png";
export { default as Img22 } from "./img/img_22.png";
export { default as Img23 } from "./img/img_23.jpg";
export { default as Img24 } from "./img/img_24.png";
export { default as Img25 } from "./img/img_25.png";
export { default as Img26 } from "./img/img_26.png";
export { default as Img27 } from "./img/img_27.png";
export { default as Img28 } from "./img/img_28.png";
export { default as Img29 } from "./img/img_29.jpeg";
export { default as Img30 } from "./img/img_30.jpg";
export { default as Img31 } from "./img/img_31.jpg";
export { default as Img32 } from "./img/img_32.png";
export { default as Img33 } from "./img/img_33.jpg";
export { default as Img34 } from "./img/img_34.jpg";
export { default as Img35 } from "./img/img_35.png";
export { default as Img36 } from "./img/img_36.jpg";
export { default as Img37 } from "./img/img_37.jpg";
export { default as Img38 } from "./img/img_38.jpg";
export { default as Img39 } from "./img/img_39.jpg";
export { default as Img40 } from "./img/img_40.jpg";
export { default as Img41 } from "./img/img_41.jpg";
export { default as Img42 } from "./img/img_42.jpg";

// client image
export { default as Client1 } from "./img/clients/client_1.png";
export { default as Client2 } from "./img/clients/client_2.png";
export { default as Client3 } from "./img/clients/client_3.png";
export { default as Client4 } from "./img/clients/client_4.png";
export { default as Client5 } from "./img/clients/client_5.png";
export { default as Client6 } from "./img/clients/client_6.png";
export { default as Client7 } from "./img/clients/client_7.png";
export { default as Client8 } from "./img/clients/client_8.png";
export { default as Client9 } from "./img/clients/client_9.png";
export { default as Client10 } from "./img/clients/client_10.png";
export { default as Client11 } from "./img/clients/client_11.png";
export { default as Client12 } from "./img/clients/client_12.png";

// frames image
export { default as Frame1 } from "./img/frames/frame_1.png";
export { default as Frame2 } from "./img/frames/frame_2.png";
export { default as Frame3 } from "./img/frames/frame_3.png";
export { default as Frame4 } from "./img/frames/frame_4.png";
export { default as Frame5 } from "./img/frames/frame_5.png";

// about
export { default as About1 } from "./img/about/about1.jpg";
export { default as About2 } from "./img/about/about2.png";
export { default as About3 } from "./img/about/about3.jpg";
export { default as About4 } from "./img/about/about4.jpg";
export { default as About5 } from "./img/about/about5.png";
export { default as About6 } from "./img/about/about6.png";
export { default as About7 } from "./img/about/about7.png";

// blog image
export { default as Blog1 } from "./img/blog/blog_1.jpg";
export { default as Blog2 } from "./img/blog/blog_2.jpg";
export { default as Blog3 } from "./img/blog/blog_3.jpg";
export { default as Blog4 } from "./img/blog/blog_4.jpg";
export { default as Blog5 } from "./img/blog/blog_5.jpg";
export { default as Blog6 } from "./img/blog/blog_6.jpg";
export { default as Blog7 } from "./img/blog/blog_7.jpg";
export { default as Blog8 } from "./img/blog/blog_8.jpg";
export { default as Blog9 } from "./img/blog/blog_9.jpg";
export { default as Blog10 } from "./img/blog/blog_10.jpg";
export { default as Blog11 } from "./img/blog/blog_11.jpg";
export { default as Blog12 } from "./img/blog/blog_12.jpg";
export { default as Blog13 } from "./img/blog/blog_13.jpg";
export { default as Blog14 } from "./img/blog/blog_14.jpg";
export { default as Blog15 } from "./img/blog/blog_15.jpg";
export { default as Blog16 } from "./img/blog/blog_16.jpg";
export { default as Blog17 } from "./img/blog/blog_17.jpg";
export { default as Blog18 } from "./img/blog/blog_18.jpg";
export { default as Blog19 } from "./img/blog/blog_19.jpg";
export { default as Blog20 } from "./img/blog/blog_20.jpg";
export { default as Blog21 } from "./img/blog/blog_21.jpg";
export { default as Blog22 } from "./img/blog/blog_22.jpg";
export { default as Blog23 } from "./img/blog/blog_23.jpg";
export { default as Blog24 } from "./img/blog/blog_24.jpg";
export { default as Blog25 } from "./img/blog/blog_25.jpg";
export { default as Blog26 } from "./img/blog/blog_26.jpg";
export { default as Blog27 } from "./img/blog/blog_27.jpg";
export { default as Blog28 } from "./img/blog/blog_28.jpg";
export { default as Blog29 } from "./img/blog/blog_29.jpg";
export { default as Blog30 } from "./img/blog/blog_30.jpg";
export { default as Blog31 } from "./img/blog/blog_31.jpg";
export { default as Blog32 } from "./img/blog/blog_32.jpg";
export { default as Blog33 } from "./img/blog/blog_33.jpg";
export { default as Blog34 } from "./img/blog/blog_34.jpg";
export { default as Blog35 } from "./img/blog/blog_35.jpg";
export { default as Blog36 } from "./img/blog/blog_36.jpg";
export { default as Blog37 } from "./img/blog/blog_37.jpg";
export { default as Blog38 } from "./img/blog/blog_38.jpg";
export { default as Blog39 } from "./img/blog/blog_39.jpg";
export { default as Blog40 } from "./img/blog/blog_40.jpg";
export { default as Blog41 } from "./img/blog/blog_41.jpg";
export { default as Blog42 } from "./img/blog/blog_42.jpg";
export { default as Blog43 } from "./img/blog/blog_43.jpg";
export { default as Blog44 } from "./img/blog/blog_44.jpg";
export { default as Blog45 } from "./img/blog/blog_45.jpg";
export { default as Blog46 } from "./img/blog/blog_46.jpg";
export { default as Blog47 } from "./img/blog/blog_47.jpg";
export { default as Blog48 } from "./img/blog/blog_48.jpg";
export { default as Blog49 } from "./img/blog/blog_49.jpg";
export { default as Blog50 } from "./img/blog/blog_50.jpg";
export { default as Blog51 } from "./img/blog/blog_51.jpg";
export { default as Blog52 } from "./img/blog/blog_52.jpg";
export { default as Blog53 } from "./img/blog/blog_53.jpg";
export { default as Blog54 } from "./img/blog/blog_54.jpg";
export { default as Blog55 } from "./img/blog/blog_55.jpg";
export { default as Blog56 } from "./img/blog/blog_56.jpg";
export { default as Blog57 } from "./img/blog/blog_57.jpg";
export { default as Blog58 } from "./img/blog/blog_58.jpg";
export { default as Blog59 } from "./img/blog/blog_59.jpg";
